module.exports = __webpack_public_path__ + "static/img/2.e5631a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/mob/2.png
// module id = uw5Q
// module chunks = 1